import { router, usePage } from "@inertiajs/react";
import Modal from "./modal";
import Button from "../buttons/button";
import { FormattedMessage } from "react-intl";
import { useState } from "react";

export default function PrivacyPolicyModal() {
    const { auth } = usePage().props;
    const policies = auth.user.needsToAcceptPolicy;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    if (
        !policies ||
        ["privacy-policy", "terms-of-use"].includes(route().current() || "")
    ) {
        return null;
    }

    const acceptPolicy = () => {
        policies.forEach((policy) => {
            router.post(
                route("accept-privacy-policy", policy.id),
                {},
                {
                    onStart: () => {
                        setLoading(true);
                        setError(false);
                    },
                    onError: () => setError(true),
                    onFinish: () => setLoading(false),
                },
            );
        });
    };
    return (
        <Modal
            open={true}
            title="We’ve updated our Terms of Use and Privacy Policy"
        >
            <div className="flex flex-col">
                <div className="prose prose-sm">
                    <span>
                        <FormattedMessage id="To help keep the Voice community safe, we’ve made some important updates to our Terms of Use and Privacy Policy." />
                    </span>
                    <h3>
                        <FormattedMessage id="What's changed:" />
                    </h3>
                    <p>
                        <FormattedMessage id="We’ve added a section that explains how we may share certain technical details about your device and browsing activity with trusted fraud prevention service providers. This helps us detect unusual activity and prevent misuse of the Voice Platform." />
                    </p>
                    <h3>
                        <FormattedMessage id="Why this matters:" />
                    </h3>
                    <p>
                        <FormattedMessage id="As part of our responsibility to researchers, partners and our Voice community, we must ensure that everyone engaging through the platform is genuine. These updates support the safety and integrity of the community and ensure that the insights you share continue to have real impact." />
                    </p>
                    <p>
                        <FormattedMessage
                            id="To continue using the Voice Platform, please review and accept the new <terms>Terms of Use</terms> and <privacy>Privacy Policy.</privacy>"
                            values={{
                                terms: (contents) => (
                                    <a
                                        href="/terms-of-use"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="underline"
                                    >
                                        {contents}
                                    </a>
                                ),
                                privacy: (contents) => (
                                    <a
                                        href="/privacy-policy"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="underline"
                                    >
                                        {contents}
                                    </a>
                                ),
                            }}
                        />
                    </p>
                </div>
                {error && (
                    <span className="text-xs text-red-600">
                        <FormattedMessage id="An error occurred while processing your request" />
                    </span>
                )}

                <div className="flex justify-end">
                    <Button
                        color="black"
                        onClick={acceptPolicy}
                        loading={loading}
                    >
                        <FormattedMessage id="Accept" />
                    </Button>
                </div>

                <p className="text-xs pt-4 text-gray-600">
                    <FormattedMessage id="For queries relating to any changes made to these terms, or should you wish to cancel your account, please contact" />{" "}
                    <a
                        href="mailto:hello@voice-global.org"
                        className="text-red-600"
                    >
                        hello@voice-global.org
                    </a>
                </p>
            </div>
        </Modal>
    );
}
